<template>
    <div class="enigma-header"
        :style="{
            'border-bottom': colors.theme == 'dark' ? '1px solid #8998a940':'1px solid #8998a940',
            backgroundColor: enigma.status == 'enigma-closed' ? colors.secondary: ''
        }"
        :class="`header-${enigma.status}`">
        <!-- Enigma Fechado -->
        <div class="closed" v-if="enigma.status == 'enigma-closed'">
            <letter :status="enigma.status" :letter="enigma.letter" :fontSize="16" :width="30"></letter>
            <div class="enigma-break" :style="colorClosed">
                {{enigma.enigma}}
            </div>
            <div class="new-suggestion" v-if="showAlertSuggestion">
                <span class="suggestion">{{$t("components.EnigmaToggle.EnigmaHeader.suggestion")}}</span>
            </div>
        </div>
        <!-- Enigma Aberto -->
        <div class="open" v-if="enigma.status == 'enigma-open'">
            <div class="letter-open">
                <letter :status="enigma.status" :letter="enigma.letter" :fontSize="23" :width="40" v-if="enigma.letter"></letter>
            </div>
            <suggestion-players :team="team"
                                :index="index"
                                :lastBg="true"
                                :suggestions="suggestions"
                                :selfSuggestion="selfSuggestion">
            </suggestion-players>
        </div>
    </div>
</template>
<script>
import Letter from '../../Shared/Letter.vue'
import SuggestionPlayers from '../../Shared/SuggestionPlayers'
import InfoGame from '../../Shared/InfoGame.vue'
import game from '../../../helpers/game.js'
import Bus from '../../../main.js'
export default {
    components : {
        Letter,
        SuggestionPlayers,
        InfoGame
    },
    data(){
        return{
            team: [
                {
                    id : 89,
                    name : 'Bruno Mendonça',
                    suggestion : '870'
                },
                {
                    id : 90,
                    name : 'Renata Gomes',
                    suggestion : '890'
                },
                {
                    id : 91,
                    name : 'Rodolfo Almeida',
                    suggestion : '1090'
                },
            ],
            showAlertSuggestion : false,
            lastSuggetionState : '',
            colors:{}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        Bus.$on(`newSuggestion-${this.enigma.letter}`, this.showNewSuggestion)
        Bus.$on(`close-${this.enigma.letter}`, this.closeNewSuggestion)
        this.$store.subscribe((mutation, state) => {
            this.lastSuggetionState = state.persistence.lastSuggestionsGroup
        })
    },
    destroyed(){
        Bus.$off(`newSuggestion-${this.enigma.letter}`)
        Bus.$off(`close-${this.enigma.letter}`)
    },
    props : {
        letter : {
            
        },
        newSuggestion : {
            
            required : false
        },
        index : {
            
        },
        enigma : {
            
            required : true
        },
        lastSuggestion : {
            required : true
        }
    },
    computed:{
        bgHeader(){
            if(this.enigma.status == 'enigma-closed'){
                return {
                    'background': 'rgb(78,61,127)',
                    'background': 'linear-gradient(270deg, rgba(78,61,127,1) 0%, rgba(98,82,162,1) 100%)'
                } 
            }else if(this.enigma.status == 'chat-closed'){
                return {
                    'background-color' : '#3c4449'
                }
            }else if(this.enigma.status == 'chat-open'){
                return {
                    'background-color' : '#000000'
                }
            }
        },
        colorClosed(){
            return {
                'color' :  this.$store.getters.enigmaToogleStyle.colorEnigmaClosed
            }
        },
        suggestions(){
            let { group, selfPlayer, lastSuggestionsGroup } = this.$store.getters.getSimple(['group', 'selfPlayer', 'lastSuggestionsGroup'])
            let suggestions = ''
            let suggetionCalc = this.lastSuggetionState ? this.lastSuggetionState : lastSuggestionsGroup
            if(suggetionCalc && suggetionCalc[this.enigma.letter]){
                suggestions = this.createHeaderSuggestion(suggetionCalc[this.enigma.letter], group, selfPlayer, this.enigma.letter)
            }
            return suggestions
        },
        selfSuggestion(){
            let { selfPlayer, lastSuggestionsGroup } = this.$store.getters.getSimple(['selfPlayer', 'lastSuggestionsGroup'])
            let selfSuggestion = ''
            let suggetionCalc = this.lastSuggetionState ? this.lastSuggetionState : lastSuggestionsGroup
            if(suggetionCalc && suggetionCalc[this.enigma.letter]){
                selfSuggestion = this.selfHeaderSuggestion(selfPlayer, suggetionCalc[this.enigma.letter])
            }
            return selfSuggestion
        }
    },
    methods:{
        showNewSuggestion(){
            this.showAlertSuggestion = true
        },
        closeNewSuggestion(){
            this.showAlertSuggestion = false
        },
        selfHeaderSuggestion(selfPlayer, suggestionLetter){
            let selfSuggestion = ''
            for(var suggestion in suggestionLetter){
                if(suggestionLetter[suggestion][0].userId == selfPlayer.id){
                    selfSuggestion = suggestionLetter[suggestion][0]
                }
            }
            if(!selfSuggestion){
                selfPlayer.suggestion = '--'
                return selfPlayer
            }

            return selfSuggestion
        },
        createHeaderSuggestion(suggestionLetter, group, selfPlayer, letter){
            // remover o selfPlayer do Group
            let groupHeader = group.filter(member => {
                return member.id != selfPlayer.id
            })

            let groupReturn = groupHeader
            let newGroup = []

            // adicionar cada tentativa em seu membro do group
            let suggestions = []
            let suggestionsMatch = []
            for(var suggestion in suggestionLetter){
                suggestions.push(suggestionLetter[suggestion][0])
            }
            suggestions.forEach(suggestion => {
                if(suggestion.enigmaOrder == letter){
                    groupHeader.forEach(member => {
                        if(member.id == suggestion.userId){
                            suggestionsMatch.push(suggestion)
                        }
                    })
                }
            })
            groupReturn.forEach(member => {
                suggestionsMatch.forEach(suggestion => {
                    if(member.id == suggestion.userId){
                        let newMember = Object.assign({}, member)
                        newMember.suggestion = suggestion.attempt
                        newGroup.push(newMember)
                    }
                })
            })
            switch(newGroup.length){
                case 0:
                    groupReturn.forEach(member => {
                        let newMember = member
                        newMember.suggestion = '--'
                        newGroup.push(member)
                    })
                    break;
                case 1:
                    groupReturn.forEach(member => {
                        if(newGroup[0].id != member.id){
                            let newMember = member
                            newMember.suggestion = '--'
                            newGroup.push(member)
                        }
                    })
                    break;
                case 2:
                    groupReturn.forEach((member, index) => {
                        if(!newGroup.some(player => player.id == member.id)){
                            let newMember = member
                            newMember.suggestion = '--'
                            newGroup.push(member)
                        }
                    })
                    break;
            }
            return newGroup
        }
    }
}
</script>
<style lang="scss" scoped>
    .header-enigma-closed{
        // background: linear-gradient(270deg, rgb(78, 61, 127) 0%, rgb(98, 82, 162) 100%);

        &:last-child{
            background: linear-gradient(270deg, rgba(89,74,146,1) 0%, rgba(70,56,114,1) 100%);
        }
    }

    .chat-icon{

        width: 40px;
    }

    .enigma-header{

        width: 100%;
        height: 90px;
        display: flex;
        align-items: center;
        // background-color: #7df5fe;
        cursor: pointer;
        border-bottom: 1px solid #ffffff1f;

        .closed, .open{

            width: 90%;
            margin: 0 auto;
            display: flex;
            align-items: center;
        }

        .open{

            width: 100%;
            height: 100%;

            .letter-open{

                margin-left: 5%;
            }
        }

        .closed{
            
            .enigma-break{

                white-space: nowrap; 
                width: 70%;
                overflow: hidden;
                text-overflow: ellipsis; 
                margin: 0 4%;
                font-weight: 500;
            }

            .new-suggestion{

                background-color: #ff0055;
                color: white;
                font-weight: 600;
                text-transform: uppercase;
                font-size: 0.5em;
                height: 18px;
                max-width: 95px;
                min-width: 95px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 3px;
                letter-spacing: 1px;
            }
        }

        .chat-closed{

            justify-content: space-between;
            background-color: #3c4449;

            .last-message{

                width: 70%;
                display: flex;
                flex-direction: column;

                .name-player{

                    font-weight: bold;
                    text-transform: uppercase;
                    color: white;
                    font-size: 11px;
                    letter-spacing: 1px;
                }

                .message-player{

                    font-size: 11px;
                    color: rgb(212, 212, 212);
                    white-space: nowrap; 
                    width: 55%;
                    overflow: hidden;
                    text-overflow: ellipsis;

                }
            }

            .count-message{

                .number-message{

                    background-color: #ff0055;
                    color: white;
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-weight: bold;
                }
            }
        }

        .chat-open{

            width: 100%;

            .open-letter{

                display: flex;
                align-items: center;
                width: 90%;
                margin: 0 auto;

                .chat-title{

                    font-weight: bold;
                    font-size: 15px;
                    color: white;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                    margin-left: 5%;
                }
            }

            .infos-game{
                display: flex;
                justify-content: flex-end;
                width: 75%;
            }
        }
    }

    @media only screen and (max-width : 350px) {

        .enigma-header{

            .closed{

                .enigma-break{
                    margin: 0 6%;
                    width: 50%;
                }

                .new-suggestion{

                    max-width: 80px;
                    min-width: 80px;
                    font-size: 7px;
                }
            }
        }

    }

    @media only screen and (max-width : 500px) {
        .enigma-header{
            .closed{
                .enigma-break{
                    width: 50%;
                }
                .new-suggestion{
                    font-size: 7px;
                    max-width: 85px;
                    min-width: 85px;
                }
            }
        }
    }
    
    @media only screen and (min-width : 750px) {
        .enigma-header {

            height: 55px;

            .chat-closed{

                .last-message{
                    

                    width: 84%;
                }
            }

            .chat-open{

                .infos-game{

                    width: 80%;
                }   
            }
        } 
    }
</style>
